import { type LayoutMode } from './types';
import { hostedDesktopPages } from './hosted/desktop';
import { hostedMobilePages } from './hosted/mobile';
import { embeddedDesktopPages, embeddedMobilePages } from './embedded';

export * from './types';

/**
 * pages — Every page component, keyed by layout mode.
 *
 * Lets callers resolve a whole page set once (`pages[mode]`) and render
 * `Page.AppPicker`, `Page.AgentStart`, … instead of branching on
 * `isEmbedded` / `isMobile` at every state.
 *
 * `hostedMobile` keeps its wider type so `pages.hostedMobile.FlowStart` stays
 * reachable — the `mobileFlowStart` state is hosted-mobile-only by construction.
 */
export const pages = {
  hostedDesktop: hostedDesktopPages,
  hostedMobile: hostedMobilePages,
  embeddedDesktop: embeddedDesktopPages,
  embeddedMobile: embeddedMobilePages,
};

/**
 * Resolves the active layout mode. Inside an iframe Ronan is embedded:
 * embedded mobile (the drawer) on phones only, embedded desktop (the card) on
 * tablets and computers. Otherwise it is hosted, where tablets count as mobile.
 */
export function resolveLayoutMode({
  isMobile,
  isEmbedded,
  isPhone,
}: {
  isMobile: boolean;
  isEmbedded: boolean;
  isPhone: boolean;
}): LayoutMode {
  if (isEmbedded) return isPhone ? 'embeddedMobile' : 'embeddedDesktop';
  return isMobile ? 'hostedMobile' : 'hostedDesktop';
}
